module.exports = __webpack_public_path__ + "static/media/blockchain-blog.db9546bc.png";